const isMapsApiEnabled = true;
// eslint-disable-next-line import/prefer-default-export
export { isMapsApiEnabled };
